export default "__VITE_ASSET__BrsD2a3L__"